<div class="category-admin-page">

  <!-- PAGE HEADER -->

  <div class="page-header">
    <div>
      <p class="eyebrow">
        {{ t('storeManagement') }}
      </p>

      <h2>
        📂 {{ t('categoryManagementTitle') }}
      </h2>

      <p class="header-text">
        {{ t('categoryManagementDesc') }}
      </p>
    </div>

    <!-- 🗑️ ট্র্যাশে যাওয়ার শর্টকাট -->
    <button type="button" class="trash-toggle-btn" (click)="goToTrash()">
      🗑️ Trash ({{ trashItems.length }})
    </button>
  </div>


  <!-- BULK IMPORT (taxonomy Excel) -->

  <section class="panel">

    <div class="panel-heading">
      <div>
        <h3>📥 Import Categories (Bulk)</h3>
        <p>
          Main/Sub/Child taxonomy .xlsx ফাইল আপলোড করলে সব category
          একবারে তৈরি হয়ে যাবে (ছবি ছাড়া — সেটা পরে এখান থেকে আলাদা
          করে বসাতে হবে)। আগে থেকে থাকা category আবার তৈরি হবে না।
        </p>
      </div>
    </div>

    <div class="form-grid">

      <div class="field">
        <label>Taxonomy Excel (.xlsx)</label>
        <input
          type="file"
          accept=".xlsx"
          (change)="onImportFileSelected($event)"
        >
      </div>

      <div class="field">
        <button
          type="button"
          class="save-btn"
          [disabled]="!importFile || importing"
          (click)="runCategoryImport()"
        >
          {{ importing ? 'আপলোড হচ্ছে...' : 'Import শুরু করো' }}
        </button>
      </div>

    </div>

    <div *ngIf="importResult" class="import-result">
      <p>✅ Main তৈরি হয়েছে: {{ importResult.mainCreated }}</p>
      <p>✅ Sub তৈরি হয়েছে: {{ importResult.subCreated }}</p>
      <p>✅ Child তৈরি হয়েছে: {{ importResult.childCreated }}</p>
      <p>⏭️ আগে থেকে ছিল (skip): {{ importResult.skippedExisting }}</p>

      <div *ngIf="importResult.errors.length">
        <p>⚠️ {{ importResult.errors.length }}টা সমস্যা হয়েছে:</p>
        <ul>
          <li *ngFor="let e of importResult.errors">{{ e }}</li>
        </ul>
      </div>

      <button
        *ngIf="importResult.batchId"
        type="button"
        class="undo-import-btn"
        [disabled]="undoingBatchId === importResult.batchId"
        (click)="undoImport(importResult.batchId, importResult.mainCreated + importResult.subCreated + importResult.childCreated)"
      >
        ↩️ ভুল হয়েছে? এই Import বাতিল করো
      </button>
    </div>

    <!-- IMPORT HISTORY -->

    <div class="import-history" *ngIf="importBatches.length">

      <h4>🕘 আগের Import-গুলো</h4>

      <p class="hint">
        কোনো Import ভুল হলে এখান থেকে বাতিল করা যায় — ওই Import-এ তৈরি সব
        ক্যাটাগরি ট্র্যাশে চলে যাবে (যেসব ক্যাটাগরিতে প্রোডাক্ট আছে সেগুলো বাদে)।
      </p>

      <div class="import-history-row" *ngFor="let b of importBatches">

        <div>
          <strong>{{ formatDateTime(b.importedAt) }}</strong>
          <span>{{ b.activeCount }}টি ক্যাটাগরি এখনো সক্রিয়</span>
        </div>

        <button
          type="button"
          class="undo-import-btn"
          [disabled]="undoingBatchId === b.batchId"
          (click)="undoImport(b.batchId, b.activeCount)"
        >
          {{ undoingBatchId === b.batchId ? 'হচ্ছে...' : '↩️ Import বাতিল' }}
        </button>

      </div>

    </div>

  </section>

  <!-- BULK IMAGE IMPORT (ফোল্ডার / ছবি / ZIP) -->

  <section class="panel">

    <div class="panel-heading">
      <div>
        <h3>🖼️ Import Category Images (Bulk)</h3>
        <p>
          সব ক্যাটাগরির ছবি একটা ফোল্ডারে রেখে এখানে দিলেই হবে — Main, Sub,
          Child যেকোনো লেভেলের ক্যাটাগরিতে ফাইলের নাম দেখে ছবি বসে যাবে।
          ফাইলের নাম হবে ক্যাটাগরির নাম (যেমন <b>Mobile Phones.jpg</b>) অথবা
          ক্যাটাগরি ID (যেমন <b>18267.jpg</b>)। একই নামের একাধিক ক্যাটাগরি
          থাকলে উপরের ক্যাটাগরির নামে সাবফোল্ডার করো। ফাইলের নাম না মিললে ফোল্ডারের নাম দেখেও ক্যাটাগরি ধরা হয় (যেমন Smartphones ফোল্ডারের ভিতরের ছবি Smartphones-এ যাবে)। উদাহরণ (
          <b>Mobile Phones/Smartphones.jpg</b>)।
        </p>
      </div>
    </div>

    <div class="form-grid">

      <div class="field">
        <label>ছবির ফোল্ডার (সাবফোল্ডারসহ)</label>
        <input
          type="file"
          webkitdirectory
          directory
          multiple
          (change)="onImageFilesSelected($event)"
        >
      </div>

      <div class="field">
        <label>অথবা ছবি / ZIP ফাইল বেছে নাও</label>
        <input
          type="file"
          multiple
          accept="image/*,.zip,.avif,.heic,.heif,.jfif,.svg,.ico,.jp2,.tif,.tiff"
          (change)="onImageFilesSelected($event)"
        >
      </div>

      <div class="field">
        <label class="check-row">
          <input type="checkbox" [(ngModel)]="imageOverwrite">
          <span>আগে থেকে ছবি থাকলেও বদলে দাও</span>
        </label>
        <label class="check-row">
          <input type="checkbox" [(ngModel)]="imageApplyAllSameName">
          <span>একই নামের সব ক্যাটাগরিতে ছবিটা বসাও</span>
        </label>
      </div>

      <div class="field">
        <button
          type="button"
          class="save-btn"
          [disabled]="!imageFiles.length || imageImporting"
          (click)="runImageImport()"
        >
          {{ imageImporting
              ? (imageProgress || 'আপলোড হচ্ছে...')
              : 'ছবি Import শুরু করো (' + imageFiles.length + 'টা ফাইল)' }}
        </button>
      </div>

    </div>

    <div *ngIf="imageResult" class="import-result">
      <p>🖼️ মোট ছবি: {{ imageResult.totalImages }}</p>
      <p>✅ ছবি বসেছে (ক্যাটাগরি): {{ imageResult.categoriesUpdated }}</p>
      <p *ngIf="imageResult.skippedAlreadyHasImage">
        ⏭️ আগে থেকে ছবি ছিল (skip): {{ imageResult.skippedAlreadyHasImage }}
      </p>

      <div *ngIf="imageResult.unmatchedFiles.length">
        <p>❓ নাম কোনো ক্যাটাগরির সাথে মেলেনি ({{ imageResult.unmatchedFiles.length }}টা):</p>
        <ul>
          <li *ngFor="let n of imageResult.unmatchedFiles">{{ n }}</li>
        </ul>
      </div>

      <div *ngIf="imageResult.ambiguousFiles.length">
        <p>⚠️ একই নামের একাধিক ক্যাটাগরি — বসানো হয়নি ({{ imageResult.ambiguousFiles.length }}টা):</p>
        <ul>
          <li *ngFor="let n of imageResult.ambiguousFiles">{{ n }}</li>
        </ul>
      </div>

      <div *ngIf="imageResult.duplicateFiles.length">
        <p>♻️ একই ক্যাটাগরির আরেকটা ছবি আগেই বসেছে ({{ imageResult.duplicateFiles.length }}টা):</p>
        <ul>
          <li *ngFor="let n of imageResult.duplicateFiles">{{ n }}</li>
        </ul>
      </div>

      <div *ngIf="imageResult.failedFiles.length || imageResult.errorMessages.length">
        <p>❌ সমস্যা হয়েছে:</p>
        <ul>
          <li *ngFor="let e of imageResult.errorMessages">{{ e }}</li>
        </ul>
      </div>
    </div>

  </section>

  <!-- 🕘 ছবি IMPORT ইতিহাস (Undo / Redo / ছবি বদল) -->

  <section class="panel img-history" *ngIf="imgBatches.length || imgTrash.length || imgMsg">

    <div class="panel-heading">
      <div>
        <h3>🕘 ছবি Import-এর ইতিহাস</h3>
        <p>
          ছবি পছন্দ না হলে পুরো Import <b>Undo</b> করো — ক্যাটাগরিগুলো আগের ছবিতে ফিরবে,
          পরে চাইলে <b>Redo</b> দিয়ে আবার আনা যাবে। কোনো একটা ছবি পছন্দ না হলে
          "খোলো" চেপে শুধু সেটা Undo বা অন্য ছবি দিয়ে বদলাও।
          (যে ক্যাটাগরির ছবি পরে হাতে বদলানো হয়েছে, Undo/Redo সেটা ছোঁয় না।)
        </p>
      </div>
    </div>

    <p class="img-msg" *ngIf="imgMsg">{{ imgMsg }}</p>

    <div class="img-batch" *ngFor="let b of imgBatches">

      <div class="img-batch-head">

        <div class="img-batch-info">
          <strong>{{ formatDateTime(b.createdAt) }}</strong>
          <span>{{ b.label || 'ছবি Import' }}</span>
          <span class="img-status" [class.undone]="b.status === 'UNDONE'">{{ imgStatusText(b) }}</span>
        </div>

        <div class="img-batch-actions">
          <button type="button" (click)="toggleBatch(b)">
            {{ openBatchId === b.batchId ? '▲ বন্ধ করো' : '▼ খোলো (' + b.total + ')' }}
          </button>

          <button
            type="button"
            class="undo-import-btn"
            *ngIf="b.active > 0"
            [disabled]="!!imgBusy"
            (click)="undoImageBatch(b)"
          >
            {{ imgBusy === 'undo:' + b.batchId ? 'হচ্ছে...' : '↩️ সব Undo' }}
          </button>

          <button
            type="button"
            class="redo-import-btn"
            *ngIf="b.active < b.total"
            [disabled]="!!imgBusy"
            (click)="redoImageBatch(b)"
          >
            {{ imgBusy === 'redo:' + b.batchId ? 'হচ্ছে...' : '↪️ সব Redo' }}
          </button>

          <button
            type="button"
            class="img-delete-btn"
            [disabled]="!!imgBusy"
            (click)="deleteImageBatch(b)"
          >
            {{ imgBusy === 'del:' + b.batchId ? 'হচ্ছে...' : '🗑️ Delete' }}
          </button>
        </div>

      </div>

      <div class="img-items" *ngIf="openBatchId === b.batchId">

        <div class="img-item" *ngFor="let it of openBatchItems">

          <div class="img-pair">
            <div class="img-box">
              <small>আগে</small>
              <img *ngIf="it.previousImageUrl" [src]="it.previousImageUrl" loading="lazy" alt="">
              <div class="img-empty" *ngIf="!it.previousImageUrl">ছবি ছিল না</div>
            </div>
            <div class="img-box">
              <small>Import-এর ছবি</small>
              <img *ngIf="it.newImageUrl" [src]="it.newImageUrl" loading="lazy" alt="">
            </div>
          </div>

          <div class="img-item-name" [title]="it.fileName">{{ it.categoryName }}</div>
          <div class="img-item-file">{{ it.fileName }}</div>
          <div class="img-item-state" [class.undone]="it.reverted">
            {{ it.reverted ? 'এখন: আগের অবস্থায়' : 'এখন: Import-এর ছবি বসানো' }}
          </div>

          <div class="img-item-actions">
            <button
              type="button"
              *ngIf="!it.reverted"
              [disabled]="!!imgBusy"
              (click)="undoImageItem(it)"
            >↩️ Undo</button>

            <button
              type="button"
              *ngIf="it.reverted"
              [disabled]="!!imgBusy"
              (click)="redoImageItem(it)"
            >↪️ Redo</button>

            <label class="img-replace" [class.disabled]="!!imgBusy">
              🔄 অন্য ছবি দাও
              <input
                type="file"
                accept="image/*,.avif,.heic,.heif,.jfif,.svg"
                [disabled]="!!imgBusy"
                (change)="replaceImageItem(it, $event)"
                hidden
              >
            </label>
          </div>

        </div>

        <button
          type="button"
          class="img-more"
          *ngIf="openBatchItems.length < openBatchTotal"
          (click)="loadBatchItems(true)"
        >আরও দেখাও ({{ openBatchItems.length }} / {{ openBatchTotal }})</button>

      </div>

    </div>

  
    <!-- 🗑️ ছবি Import ট্র্যাশ -->

    <div class="img-trash" *ngIf="imgTrash.length">

      <div class="img-trash-head">
        <h4>🗑️ ট্র্যাশ ({{ imgTrash.length }})</h4>
        <button
          type="button"
          class="img-delete-btn"
          [disabled]="!!imgBusy"
          (click)="emptyImageTrash()"
        >
          {{ imgBusy === 'empty' ? 'হচ্ছে...' : '❌ ট্র্যাশ খালি করো' }}
        </button>
      </div>

      <p class="hint">
        এখানকার Import-গুলোর ছবি ক্যাটাগরি থেকে সরানো আছে। Restore করলে ছবি আবার বসবে,
        চিরতরে মুছলে ইতিহাস আর আপলোড করা ছবি একেবারে চলে যাবে।
      </p>

      <div class="img-batch img-trash-row" *ngFor="let t of imgTrash">

        <div class="img-batch-info">
          <strong>{{ formatDateTime(t.createdAt) }}</strong>
          <span>{{ t.label || 'ছবি Import' }} — {{ t.total }}টা ক্যাটাগরি</span>
          <span class="img-status undone">🗑️ ট্র্যাশে গেছে: {{ formatDateTime(t.deletedAt) }}</span>
        </div>

        <div class="img-batch-actions">
          <button
            type="button"
            class="redo-import-btn"
            [disabled]="!!imgBusy"
            (click)="restoreImageBatch(t)"
          >
            {{ imgBusy === 'res:' + t.batchId ? 'হচ্ছে...' : '♻️ Restore' }}
          </button>

          <button
            type="button"
            class="img-delete-btn"
            [disabled]="!!imgBusy"
            (click)="purgeImageBatch(t)"
          >
            {{ imgBusy === 'purge:' + t.batchId ? 'হচ্ছে...' : '❌ চিরতরে মুছো' }}
          </button>
        </div>

      </div>

    </div>

  </section>


  <!-- CATEGORY FORM -->

  <section class="panel">

    <div class="panel-heading">

      <div>
        <h3>
          {{
            editingId
              ? t('editCategory')
              : t('addNewCategoryTitle')
          }}
        </h3>

        <p>
          {{ t('createCategoriesDesc') }}
        </p>
      </div>

      <button
        *ngIf="editingId"
        type="button"
        class="cancel-btn"
        (click)="reset()"
      >
        {{ t('cancelEdit') }}
      </button>

    </div>


    <div class="form-grid">

      <!-- NAME -->

      <div class="field">

        <label>
          {{ t('categoryNameEnglishLabel') }}
        </label>

        <input
          type="text"
          [(ngModel)]="form.name"
          (blur)="autoFillCategoryNameBn()"
          placeholder="Enter category name"
        >

      </div>


      <!-- NAME (BANGLA) -->

      <div class="field">

        <label>
          Category Name (Bangla) 🇧🇩
        </label>

        <input
          type="text"
          [(ngModel)]="form.nameBn"
          (blur)="autoFillCategoryNameEn()"
          placeholder="ইংরেজি নাম লিখে বাইরে ক্লিক করলে অটো বাংলা বসে যাবে"
        >

        <small class="hint" *ngIf="translatingCategoryName">
          ⏳ {{ t('loading') }}
        </small>

        <small class="hint" *ngIf="!translatingCategoryName">
          এখানে বাংলা নাম লিখলে ওয়েবসাইট "বাংলা" মোডে থাকলে এটাই দেখাবে। ইংরেজি লিখে অন্য ফিল্ডে ক্লিক করলেই অটোমেটিক বাংলা বসে যাবে (চাইলে নিজে এডিটও করতে পারবেন)।
        </small>

      </div>


      <!-- TYPE -->

      <div class="field">

        <label>
          {{ t('categoryType') }}
        </label>

        <select
          [(ngModel)]="form.type"
        >

          <option value="MAIN">
            {{ t('mainCategory') }}
          </option>

          <option value="SUB">
            {{ t('subCategory') }}
          </option>

          <option value="CHILD">
            {{ t('childCategory') }}
          </option>

        </select>

      </div>


      <!-- SUB PARENT -->

      <div
        class="field"
        *ngIf="form.type === 'SUB'"
      >

        <label>
          {{ t('parentMainCategory') }}
        </label>

        <select
          [(ngModel)]="form.parentId"
        >

          <option [ngValue]="null">
            {{ t('selectMainCategory') }}
          </option>

          <option
            *ngFor="let c of mainCategories"
            [ngValue]="c.id"
          >
            {{ languageService.translateCategory(c.name, c.nameBn) }}
          </option>

        </select>

      </div>


      <!-- CHILD PARENT -->

      <div
        class="field"
        *ngIf="form.type === 'CHILD'"
      >

        <label>
          {{ t('parentSubCategory') }}
        </label>

        <select
          [(ngModel)]="form.parentId"
        >

          <option [ngValue]="null">
            {{ t('selectSubCategory') }}
          </option>

          <option
            *ngFor="let c of subCategories"
            [ngValue]="c.id"
          >
            {{ languageService.translateCategory(c.parent?.name, c.parent?.nameBn) }}
            →
            {{ languageService.translateCategory(c.name, c.nameBn) }}
          </option>

        </select>

      </div>


      <!-- IMAGE -->

      <div class="field">

        <label>
          {{ t('categoryImage') }}
        </label>

        <input
          type="file"
          accept="image/*"
          (change)="onFileSelected($event)"
        >

      </div>

    </div>


    <!-- IMAGE PREVIEW -->

    <div
      class="image-preview-box"
      *ngIf="previewImage"
    >

      <img
        [src]="previewImage"
        alt="Category preview"
        (error)="onImageError($event)"
      >

      <span>
        {{ t('imagePreview') }}
      </span>

    </div>


    <!-- SAVE BUTTON -->

    <div class="form-actions">

      <button
        type="button"
        class="primary-btn"
        [disabled]="saving"
        (click)="save()"
      >

        {{
          saving
            ? t('savingEllipsis')
            : (
                editingId
                  ? t('updateCategory')
                  : t('addCategory')
              )
        }}

      </button>

    </div>

  </section>


  <!-- ALL CATEGORY TREE -->

  <section class="panel">

    <div class="panel-heading">

      <div>

        <h3>
          {{ t('allCategories') }}
        </h3>

        <p>
          {{ t('manageCategoryStructure') }}
        </p>

        <p class="order-hint">
          💡 প্রতিটি Main Category বা Sub Category-র পাশে "Order" বক্সে সংখ্যা বসিয়ে Save করলে
          ওয়েবসাইটের sidebar ও ক্যাটাগরি পেজে সেই ক্রমেই দেখাবে —
          ছোট সংখ্যা আগে দেখাবে। Main/Sub-এর নামের পাশের ▶ চাপলে ভেতরের ক্যাটাগরি খুলবে।
        </p>

      </div>

    </div>


    <!-- SEARCH -->

    <div class="search-bar">

      <input
        type="text"
        class="category-search"
        placeholder="🔍 Main / Sub / Child যেকোনো ক্যাটাগরির নাম লিখুন (English বা বাংলা)..."
        [ngModel]="categorySearch"
        (ngModelChange)="categorySearch = $event; onSearchInput()"
      />

      <button
        type="button"
        class="search-clear-btn"
        *ngIf="categorySearch"
        (click)="clearSearch()"
        title="সার্চ মুছুন"
      >
        ✕
      </button>

    </div>

    <div class="search-filters">

      <button
        type="button"
        class="filter-chip"
        *ngFor="let f of typeFilters"
        [class.active]="searchType === f.value"
        (click)="setSearchType(f.value)"
        [hidden]="!isSearching"
      >
        {{ f.label }}
      </button>

      <span class="tree-stats">
        মোট: {{ stats.main }} Main · {{ stats.sub }} Sub · {{ stats.child }} Child
      </span>

      <button
        type="button"
        class="collapse-btn"
        *ngIf="!isSearching && expandedIds.size"
        (click)="collapseAll()"
      >
        ▲ সব বন্ধ করুন
      </button>

    </div>


    <!-- BULK SELECT TOOLBAR -->

    <div class="bulk-bar" *ngIf="categories.length > 0">

      <label class="bulk-check-all" *ngIf="!isSearching">
        <input
          type="checkbox"
          [checked]="allMainSelected"
          (change)="toggleSelectAllMain()"
        >
        সব Main Category বাছাই
      </label>

      <span class="bulk-count" *ngIf="selectedCount">
        {{ selectedCount }}টি বাছাই করা হয়েছে
      </span>

      <button
        type="button"
        class="bulk-delete-btn"
        *ngIf="selectedCount"
        [disabled]="deleting"
        (click)="bulkDelete()"
      >
        🗑️ বাছাইগুলো ট্র্যাশে পাঠাও
      </button>

      <button
        type="button"
        class="bulk-clear-btn"
        *ngIf="selectedCount"
        (click)="clearSelection()"
      >
        বাছাই বাতিল
      </button>

    </div>


    <!-- LOADING (শুধু প্রথমবার; রিলোডে ট্রি আর ঝলকায় না) -->

    <div
      class="loading-box"
      *ngIf="loading && categories.length === 0"
    >
      {{ t('loadingCategories') }}
    </div>


    <!-- EMPTY -->

    <div
      class="loading-box"
      *ngIf="!loading && categories.length === 0"
    >
      {{ t('noCategoriesFound') }}
    </div>


    <!-- ============ SEARCH RESULTS ============ -->

    <div
      class="category-tree"
      *ngIf="isSearching && categories.length > 0"
    >

      <div class="search-meta">

        <ng-container *ngIf="searchTotal">
          "{{ categorySearch }}" — {{ searchTotal }}টি পাওয়া গেছে
          <span *ngIf="searchTotal > searchResults.length">
            (প্রথম {{ searchResults.length }}টি দেখাচ্ছে)
          </span>
        </ng-container>

        <ng-container *ngIf="!searchTotal">
          কিছু পাওয়া যায়নি — অন্য বানানে বা ছোট করে লিখে দেখুন
        </ng-container>

      </div>

      <div
        class="category-row search-row"
        *ngFor="let r of searchResults; trackBy: trackById"
      >

        <div class="category-info">

          <input
            type="checkbox"
            class="select-box"
            [checked]="isSelected(r.id)"
            (change)="toggleSelect(r.id)"
            title="বাছাই করুন"
          >

          <div class="tree-image small">

            <img
              *ngIf="r.imageUrl"
              [src]="getImageUrl(r.imageUrl)"
              [alt]="r.name"
              loading="lazy"
              (error)="onImageError($event)"
            >

            <span *ngIf="!r.imageUrl">
              {{ r._level === 1 ? '📂' : (r._level === 2 ? '📁' : '📄') }}
            </span>

          </div>

          <div>

            <span
              class="type-label"
              [class.lvl-main]="r._level === 1"
              [class.lvl-sub]="r._level === 2"
              [class.lvl-child]="r._level === 3"
            >
              {{ levelLabel(r._level) }}
            </span>

            <strong>
              {{ languageService.translateCategory(r.name, r.nameBn) }}
            </strong>

            <small class="search-path" *ngIf="r._level > 1">
              {{ r._path }}
            </small>

          </div>

        </div>

        <div class="row-actions">

          <button
            type="button"
            class="show-tree-btn"
            (click)="revealInTree(r)"
          >
            📍 ট্রি-তে দেখাও
          </button>

          <button
            type="button"
            class="edit-btn"
            (click)="edit(r)"
          >
            {{ t('edit') }}
          </button>

          <button
            type="button"
            class="delete-btn"
            (click)="delete(r.id)"
          >
            {{ t('delete') }}
          </button>

        </div>

      </div>

      <button
        type="button"
        class="more-btn"
        *ngIf="searchTotal > searchResults.length"
        (click)="showMoreResults()"
      >
        ⬇ আরও দেখান ({{ searchTotal - searchResults.length }}টি বাকি)
      </button>

    </div>


    <!-- ============ COLLAPSIBLE TREE ============ -->

    <div
      class="category-tree"
      *ngIf="!isSearching && categories.length > 0"
    >

      <div
        class="main-category-block"
        *ngFor="let main of categories; trackBy: trackById"
      >

        <!-- MAIN CATEGORY -->

        <div
          class="category-row main-row"
          [id]="'cat-' + main.id"
          [class.row-highlight]="highlightId === main.id"
        >

          <div class="category-info">

            <button
              type="button"
              class="expand-btn"
              (click)="toggleExpand(main.id)"
              [disabled]="!main.children.length"
              [title]="isExpanded(main.id) ? 'বন্ধ করুন' : 'খুলুন'"
            >
              {{ isExpanded(main.id) ? '▼' : '▶' }}
            </button>

            <input
              type="checkbox"
              class="select-box"
              [checked]="isSelected(main.id)"
              (change)="toggleSelect(main.id)"
              title="বাছাই করুন"
            >

            <div class="tree-image">

              <img
                *ngIf="main.imageUrl"
                [src]="getImageUrl(main.imageUrl)"
                [alt]="main.name"
                loading="lazy"
                (error)="onImageError($event)"
              >

              <span *ngIf="!main.imageUrl">
                📂
              </span>

            </div>

            <div>

              <span class="type-label">
                {{ t('mainCategory') }}
              </span>

              <strong>
                {{ languageService.translateCategory(main.name, main.nameBn) }}
              </strong>

              <span class="count-badge" *ngIf="main.children.length">
                {{ main.children.length }} Sub
              </span>

            </div>

          </div>

          <div class="row-actions">

            <div class="order-control main-order-control">

              <label>
                {{ t('displayOrderLabel') }}
              </label>

              <input
                type="number"
                min="0"
                [(ngModel)]="main.displayOrder"
                style="width:70px"
              >

            </div>

            <button
              type="button"
              class="primary-btn"
              (click)="saveDisplayOrder(main)"
            >
              {{ t('save') }}
            </button>

            <button
              type="button"
              class="edit-btn"
              (click)="edit(main)"
            >
              {{ t('edit') }}
            </button>

            <button
              type="button"
              class="delete-btn"
              (click)="delete(main.id)"
            >
              {{ t('delete') }}
            </button>

          </div>

        </div>


        <ng-container *ngIf="isExpanded(main.id)">

          <ng-container *ngFor="let sub of main.children; trackBy: trackById">

            <!-- SUB CATEGORY -->

            <div
              class="category-row sub-row"
              [id]="'cat-' + sub.id"
              [class.row-highlight]="highlightId === sub.id"
            >

              <div class="category-info">

                <button
                  type="button"
                  class="expand-btn"
                  (click)="toggleExpand(sub.id)"
                  [disabled]="!sub.children.length"
                  [title]="isExpanded(sub.id) ? 'বন্ধ করুন' : 'খুলুন'"
                >
                  {{ isExpanded(sub.id) ? '▼' : '▶' }}
                </button>

                <input
                  type="checkbox"
                  class="select-box"
                  [checked]="isSelected(sub.id)"
                  (change)="toggleSelect(sub.id)"
                  title="বাছাই করুন"
                >

                <div class="tree-line">
                  ↳
                </div>

                <div class="tree-image small">

                  <img
                    *ngIf="sub.imageUrl"
                    [src]="getImageUrl(sub.imageUrl)"
                    [alt]="sub.name"
                    loading="lazy"
                    (error)="onImageError($event)"
                  >

                  <span *ngIf="!sub.imageUrl">
                    📁
                  </span>

                </div>

                <div>

                  <span class="type-label">
                    {{ t('subCategory') }}
                  </span>

                  <strong>
                    {{ languageService.translateCategory(sub.name, sub.nameBn) }}
                  </strong>

                  <span class="count-badge" *ngIf="sub.children.length">
                    {{ sub.children.length }} Child
                  </span>

                </div>

              </div>

              <div class="row-actions">

                <div class="order-control main-order-control">

                  <label>
                    {{ t('displayOrderLabel') }}
                  </label>

                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="sub.displayOrder"
                    style="width:70px"
                  >

                </div>

                <button
                  type="button"
                  class="primary-btn"
                  (click)="saveDisplayOrder(sub)"
                >
                  {{ t('save') }}
                </button>

                <button
                  type="button"
                  class="edit-btn"
                  (click)="edit(sub)"
                >
                  {{ t('edit') }}
                </button>

                <button
                  type="button"
                  class="delete-btn"
                  (click)="delete(sub.id)"
                >
                  {{ t('delete') }}
                </button>

              </div>

            </div>


            <!-- CHILD CATEGORY -->

            <ng-container *ngIf="isExpanded(sub.id)">

              <div
                class="category-row child-row"
                *ngFor="let child of sub.children; trackBy: trackById"
                [id]="'cat-' + child.id"
                [class.row-highlight]="highlightId === child.id"
              >

                <div class="category-info">

                  <input
                    type="checkbox"
                    class="select-box"
                    [checked]="isSelected(child.id)"
                    (change)="toggleSelect(child.id)"
                    title="বাছাই করুন"
                  >

                  <div class="tree-line">
                    ↳↳
                  </div>

                  <div class="tree-image tiny">

                    <img
                      *ngIf="child.imageUrl"
                      [src]="getImageUrl(child.imageUrl)"
                      [alt]="child.name"
                      loading="lazy"
                      (error)="onImageError($event)"
                    >

                    <span *ngIf="!child.imageUrl">
                      📄
                    </span>

                  </div>

                  <div>

                    <span class="type-label">
                      {{ t('childCategory') }}
                    </span>

                    <strong>
                      {{ languageService.translateCategory(child.name, child.nameBn) }}
                    </strong>

                  </div>

                </div>

                <div class="row-actions">

                  <button
                    type="button"
                    class="edit-btn"
                    (click)="edit(child)"
                  >
                    {{ t('edit') }}
                  </button>

                  <button
                    type="button"
                    class="delete-btn"
                    (click)="delete(child.id)"
                  >
                    {{ t('delete') }}
                  </button>

                </div>

              </div>

            </ng-container>

          </ng-container>

        </ng-container>

      </div>

    </div>

  </section>

  
  <!-- 🗑️ TRASH -->

  <section class="panel trash-panel" id="category-trash-panel">

    <div class="panel-heading">

      <div>
        <h3>🗑️ Category Trash ({{ trashItems.length }})</h3>
        <p>
          ডিলিট করা ক্যাটাগরি এখানে জমা থাকে এবং {{ RETENTION_DAYS }} দিন পর নিজে নিজে
          চিরতরে মুছে যায়। এর মধ্যে যেকোনো সময় ফিরিয়ে আনা যাবে।
        </p>
      </div>

      <button
        type="button"
        class="trash-toggle-btn"
        (click)="toggleTrash()"
      >
        {{ trashOpen ? 'লুকাও ▲' : 'দেখাও ▼' }}
      </button>

    </div>

    <ng-container *ngIf="trashOpen">

      <div class="loading-box" *ngIf="trashLoading && !trashGroups.length">
        ট্র্যাশ লোড হচ্ছে...
      </div>

      <div class="loading-box" *ngIf="!trashLoading && !trashGroups.length">
        ট্র্যাশ খালি ✨
      </div>

      <div class="trash-toolbar" *ngIf="trashGroups.length">

        <button
          type="button"
          class="restore-btn"
          [disabled]="trashBusy"
          (click)="restoreAllTrash()"
        >
          ♻️ সব ফিরিয়ে আনো
        </button>

        <button
          type="button"
          class="perm-delete-btn"
          [disabled]="trashBusy"
          (click)="emptyTrash()"
        >
          💥 ট্র্যাশ খালি করো
        </button>

      </div>

      <div class="trash-group" *ngFor="let g of trashGroups">

        <div class="trash-group-head">

          <div class="trash-group-info">

            <strong>{{ g.root.path }}</strong>

            <span>
              <ng-container *ngIf="g.items.length > 1">
                সহ মোট {{ g.items.length }}টি ক্যাটাগরি ·
              </ng-container>
              {{ formatDateTime(g.deletedAt) }}
              <ng-container *ngIf="g.root.deletedByName">
                · {{ g.root.deletedByName }}
              </ng-container>
              · <b [class.trash-soon]="g.daysLeft <= 5">{{ g.daysLeft }} দিন বাকি</b>
            </span>

          </div>

          <div class="trash-group-actions">

            <button
              type="button"
              class="restore-btn"
              [disabled]="trashBusy"
              (click)="restoreGroup(g)"
            >
              ♻️ Restore
            </button>

            <button
              type="button"
              class="perm-delete-btn"
              [disabled]="trashBusy"
              (click)="permanentDeleteGroup(g)"
            >
              💥 চিরতরে মোছো
            </button>

            <button
              type="button"
              class="trash-toggle-btn"
              *ngIf="g.items.length > 1"
              (click)="g.expanded = !g.expanded"
            >
              {{ g.expanded ? '▲' : '▼' }}
            </button>

          </div>

        </div>

        <div class="trash-group-items" *ngIf="g.expanded">

          <div class="trash-item" *ngFor="let it of g.items">

            <span [style.paddingLeft.px]="(it.level - g.root.level) * 18">
              {{ it.level > g.root.level ? '↳ ' : '' }}{{ it.name }}
            </span>

            <button
              type="button"
              class="restore-btn small"
              [disabled]="trashBusy"
              (click)="restoreItem(it)"
              title="শুধু এটা ফিরিয়ে আনো"
            >
              ♻️
            </button>

          </div>

        </div>

      </div>

    </ng-container>

  </section>


  <!-- POPULAR CATEGORY CONTROL — এখন "হোমপেজ ডিজাইন" পেজে সরানো হয়েছে -->

  <section class="panel popular-panel">

    <div class="panel-heading">

      <div>

        <h3>
          🔥 {{ t('popularCategories') }}
        </h3>

        <p>
          পপুলার ক্যাটাগরি এখন <b>হোমপেজ ডিজাইন</b> পেজ থেকে ঠিক করুন
          (এই পেজ হালকা রাখতে এখান থেকে সরানো হয়েছে)।
        </p>

        <a
          routerLink="/admin/homepage-design"
          class="goto-homepage-design"
        >
          🎨 হোমপেজ ডিজাইনে যান →
        </a>

      </div>

    </div>

  </section>


  <!-- ↩️ UNDO TOAST -->

  <div class="undo-toast" *ngIf="undoToast">

    <span>🗑️ {{ undoToast.message }}</span>

    <button type="button" class="undo-btn" (click)="undoDelete()">
      ↩️ Undo
    </button>

    <button type="button" class="undo-close" (click)="dismissUndo()" title="বন্ধ করুন">
      ✕
    </button>

  </div>

</div>
